<template>
  <el-select v-model="selectValue" v-bind="$attrs" v-on="$listeners" :filterable="filterable" :placeholder="placeholder">
    <el-option v-if="!empty" key="all" :label="$t('common.all')" value></el-option>
    <el-option
      v-for="option of list"
      :key="option[valueKey]"
      :label="option[labelKey]"
      :value="option[valueKey]"
      :disabled="disabledOptions.some((item) => option[valueKey].includes(item))"
    ></el-option>
  </el-select>
</template>
<script>
import i18n from '@/utils/i18n';
export default {
  name: 'BaseSelect',
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
    valueKey: {
      type: String,
      default: 'code',
    },
    labelKey: {
      type: String,
      default: 'name',
    },
    value: {
      type: [String, Number, Array],
    },
    empty: {
      type: Boolean,
      default: false,
    },
    disabledOptions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: i18n.t('common.pleaseSelect'),
    },
    filterable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.block {
  width: 100%;
}
.block[disabled='disabled'] {
  &::after {
    content: '未找到满足条件的付款';
    color: #e75235;
    font-size: 13px;
    display: block;
    line-height: 2;
    float: left;
  }
}
</style>
